module.exports = __webpack_public_path__ + "static/media/160316_PRESSCOFFE_2in1.2edd138e.jpg";